import React from 'react'
import { trabajos } from '../data/trabajos'

export const Portafolio = () => {
  return (
    <div className='page'>
        <h1 className='heading'>Tecnologias</h1>

        <section className='works'>
        {
            trabajos.map(trabajo => {
                return (
                    <article key={trabajo.id}>
                        <h2> {trabajo.Control} </h2>
                            <div className='mask'>
                                <img src={"/imagenes/"+trabajo.id+".png"} className="work-item"/>
                            </div>
                        <h3> {trabajo.tipo} </h3>
                        <h3> {trabajo.targeta} </h3>
                        <h3> {trabajo.Traccion} </h3>
                        <h3> {trabajo.Empresa} </h3>
                    </article>
                )
            })
        }
        </section>
    </div>
  )
}
